import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { getUserScopedStorageKeyPrefix } from './get-user-scoped-storage-key-prefix';
export var UserScopedSessionStorage = /*#__PURE__*/function () {
  function UserScopedSessionStorage(userId) {
    _classCallCheck(this, UserScopedSessionStorage);

    _defineProperty(this, "storageKeyPrefix", void 0);

    this.storageKeyPrefix = getUserScopedStorageKeyPrefix(userId);
  }

  _createClass(UserScopedSessionStorage, [{
    key: "getItem",
    value: function getItem(key) {
      return window.sessionStorage.getItem(this.storageKeyPrefix + key);
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      window.sessionStorage.setItem(this.storageKeyPrefix + key, value);
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      window.sessionStorage.removeItem(this.storageKeyPrefix + key);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this = this;

      Object.keys(window.sessionStorage).filter(function (key) {
        return key.startsWith(_this.storageKeyPrefix);
      }).forEach(function (key) {
        return window.sessionStorage.removeItem(key);
      });
    }
  }]);

  return UserScopedSessionStorage;
}();